import  { AxiosResponse, AxiosError, AxiosResponseHeaders } from "axios"
import axios  from "./index"
import { AuthHeaders, Complaint } from "../stores/store_types"

const callComplaintsAPI = (headers: AuthHeaders, parameter: { corporationId: number, targetMonth: Date }, successCallback: (headers: AxiosResponseHeaders, complaints:  Array<Complaint>, complaintsPublished: boolean) => void, failureCallback: () => void) => {
  axios.get(
    "/api/v1/complaints",
    {
      headers: headers,
      params: {
        corporation_id: parameter.corporationId,
        target_month: parameter.targetMonth.toString()
      }
    }
  ).then((response: AxiosResponse) => {
    successCallback(response.headers, response.data["complaints"], response.data["published"])
  }).catch((error: AxiosError) => {
    console.error(error)
    failureCallback()
  })
}

const callDownloadComplaintsAPI = (headers: AuthHeaders, parameter: { corporationId: number, targetMonth: Date }, successCallback: (headers: AxiosResponseHeaders, blob: Blob) => void, failureCallback: () => void) => {
  axios.get(
    "/api/v1/complaints.csv",
    {
      headers: headers,
      responseType: "blob",
      params: {
        corporation_id: parameter.corporationId,
        target_month: parameter.targetMonth.toString(),
      }
    }
  ).then((response: AxiosResponse) => {
    const mineType = response.headers["content-type"]
    const blob = new Blob([response.data], { type: mineType })
    successCallback(response.headers, blob)
  }).catch((error: AxiosError) => {
    console.error(error)
    failureCallback()
  })
}

const callComplaintsBulkUpdateAPI = (headers: AuthHeaders, params: Array<{id: number, complaint: string, childAge: string}>, successCallback: (headers: AxiosResponseHeaders, status: number) => void, failureCallback: () => void) => {
  axios.put(
    "/api/v1/complaints/bulk_update",
    {
      complaints: params
    },
    {
      headers: headers,
    }
  ).then((response: AxiosResponse) => {
    successCallback(response.headers, response.status)
  }).catch((error: AxiosError) => {
    console.error(error)
    failureCallback()
  })
}

export { callComplaintsAPI, callDownloadComplaintsAPI, callComplaintsBulkUpdateAPI }
